import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

const withSearch = (pathname, search) => `${pathname}${search || ''}`;

/**
 * Legacy client-portal appointment URLs (missing /account or singular appointment).
 */
export const StorefrontAppointmentLegacyRedirect = () => {
  const { companyUrl, appointmentId } = useParams();
  const { search } = useLocation();

  if (!companyUrl || !appointmentId) {
    return <Navigate to={companyUrl ? `/book/${companyUrl}/account/appointments` : '/book'} replace />;
  }

  return (
    <Navigate
      to={withSearch(`/book/${companyUrl}/account/appointments/${appointmentId}`, search)}
      replace
    />
  );
};

export const StorefrontAppointmentLegacyWildcardRedirect = () => {
  const { companyUrl, appointmentId, '*': rest } = useParams();
  const { search } = useLocation();
  const suffix = rest ? `/${rest}` : '';

  if (!companyUrl || !appointmentId) {
    return <Navigate to={companyUrl ? `/book/${companyUrl}/account/appointments` : '/book'} replace />;
  }

  return (
    <Navigate
      to={withSearch(`/book/${companyUrl}/account/appointments/${appointmentId}${suffix}`, search)}
      replace
    />
  );
};

export const StorefrontAccountLegacyRedirect = () => {
  const { companyUrl, '*': rest } = useParams();
  const { search } = useLocation();
  const suffix = rest ? `/${rest}` : '';

  if (!companyUrl) {
    return <Navigate to="/book" replace />;
  }

  return (
    <Navigate
      to={withSearch(`/book/${companyUrl}/account${suffix}`, search)}
      replace
    />
  );
};
